import { cn } from 'lib/utils';
import { Skeleton } from 'components/ui/skeleton';
import { GRID_COLS } from './tableColumns';

/** Six placeholder rows while the first page of the journal loads. */
const SkeletonRows = () => (
  <div role="rowgroup">
    {Array.from({ length: 6 }, (_, row) => (
      <div key={row} role="row" className={cn('grid items-center gap-3 border-b px-4', GRID_COLS)} style={{ height: 52 }}>
        {Array.from({ length: 6 }, (__, col) => (
          <Skeleton key={col} role="cell" className="h-4 w-4/5" />
        ))}
      </div>
    ))}
  </div>
);

export default SkeletonRows;
